// extracted by mini-css-extract-plugin
module.exports = {"container":"Box_container__3FhG8","padded":"Box_padded__rvaHy","title":"Box_title__ZPpl1","subtext":"Box_subtext__qiAnz"};